<template>
  <div>
    
<FormKitLazyProvider config-file="true">
<div class="flex items-center space-x-5" role="search">
      <FormKit
        :id="id"
        v-model.lazy="value"
        type="search"
        name="searchterm"
        autocomplete="off"
        spellcheck="false"
        role="searchbox"
        aria-owns="searchterm-suggestions"
        aria-label="Search input"
        :placeholder="$texts('enterSearchTerm', 'Suchbegriff eingeben')"
        :inner-class="{
          'formkit-shadow': true,
        }"
      />

      <button
        type="submit"
        class="button is-filled show-icon hidden md:inline-flex formkit-search-button mb-4"
      >
        {{ $texts('submitSearch', 'Suchen') }}
        <SpriteSymbol name="search" />
      </button>
    </div>
</FormKitLazyProvider>

  </div>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
defineProps<{
  id: string
  label?: string
}>()

const { $texts } = useEasyTexts()

const value = defineModel<string>()
</script>

<style lang="postcss">
.formkit-search-button {
  @apply py-4;
}

.formkit-shadow:focus-within {
  box-shadow: 0 4px 60px rgba(0, 0, 0, 0.15);
  background: transparent !important;
}
</style>
